import { JSONSchemaType } from 'ajv'
import { useCallback } from 'react'
import { parse } from 'yaml'

import { CustomComponentData } from '@/components/CustomComponent/CodeEditor'
import { CustomComponent } from '@/components/CustomComponent/CustomComponent'
import ComponentProvider from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import { CustomComponentEnhanced } from '@/screens/ComponentLibrary/hooks/CONSTANTS'
import { ComponentType } from '@/utils/api'

export default function MessageAssimilation() {
  const org = useOrg()
  const schemaName = 'AssimilationConfig'
  const schemaVersion = '1.0.0'
  const generateSchema = useCallback((schema: JSONSchemaType<unknown>) => {
    const data = {
      ...schema,
      patternProperties: schema.definitions?.Data.patternProperties,
      required: [],
    }
    return data
  }, [])

  return (
    <ComponentProvider useUrl>
      <CustomComponent
        generateSchema={generateSchema}
        label="Message Assimialtion"
        parseConfig={(
          param?: CustomComponentEnhanced<CustomComponentData>
        ): Record<string, unknown> => {
          console.log(param)
          return {
            data: parse(param?.settings?.data || ''),
            organization: org.data?.slug,
            schemaName,
            schemaVersion,
            version: '1.0.0',
          }
        }}
        schemaName={schemaName}
        schemaVersion={schemaVersion}
        type={ComponentType.messageAssimilation}
      />
    </ComponentProvider>
  )
}
